"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Explanation_1 = __importDefault(require("../Explanation"));
const common_1 = require("./common");
function Product(node) {
    return (jsx_runtime_1.jsx(common_1.Mecanism, Object.assign({ name: "produit", value: node.nodeValue, unit: node.unit }, { children: jsx_runtime_1.jsxs("div", Object.assign({ style: {
                display: 'flex',
                alignItems: 'baseline',
                flexWrap: 'wrap',
            } }, { children: [jsx_runtime_1.jsxs("div", Object.assign({ style: { textAlign: 'right' } }, { children: [jsx_runtime_1.jsx(Explanation_1.default, { node: node.explanation.assiette }, void 0), !node.explanation.plafond.isDefault && (jsx_runtime_1.jsxs(PlafondSmall, { children: [jsx_runtime_1.jsx("span", { children: "Plafonn\u00E9e \u00E0 :\u00A0" }, void 0), jsx_runtime_1.jsx(Explanation_1.default, { node: node.explanation.plafond }, void 0)] }, void 0))] }), void 0), !node.explanation.facteur.isDefault && (jsx_runtime_1.jsxs("div", Object.assign({ style: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } }, { children: [jsx_runtime_1.jsx("div", Object.assign({ style: { margin: '0 0.6rem' } }, { children: " \u00D7 " }), void 0), jsx_runtime_1.jsx("div", { children: jsx_runtime_1.jsx(Explanation_1.default, { node: node.explanation.facteur }, void 0) }, void 0)] }), void 0)), !node.explanation.taux.isDefault && (jsx_runtime_1.jsxs("div", Object.assign({ style: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } }, { children: [jsx_runtime_1.jsx("div", Object.assign({ style: { margin: '0 0.6rem' } }, { children: " \u00D7 " }), void 0), jsx_runtime_1.jsx(Explanation_1.default, { node: node.explanation.taux }, void 0)] }), void 0))] }), void 0) }), void 0));
}
exports.default = Product;
const PlafondSmall = styled_components_1.default.small `
	display: flex;
	align-items: baseline;
	justify-content: flex-end;
	flex-wrap: wrap;
`;
